import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const EmptyState = ({
  icon,
  title,
  description = "",
}: {
  icon: IconProp;
  title: string;
  description?: string;
}) => (
  <div className="mt-10 flex flex-col items-center text-center text-tertiary">
    <FontAwesomeIcon icon={icon} size="2x" className="mb-4 text-grey-medium" />
    <p className="text-lg font-oxaniumMedium text-default-text">{title}</p>
    {description !== "" && <p className="mt-1 max-w-md">{description}</p>}
  </div>
);
